import {sorting} from "@atttomyx/shared-utils";

export const sortByWord = (a, b) => sorting.sortByField(a, b, "word");

export const sanitizeWord = (word) => {
    word.id = word.word;

    return word;
};
